/**
 * Cash ActionTypes
 */
export enum Actions {
  UPDATE_PAYOUTS_CASH_INPUT = "UPDATE_PAYOUTS_CASH_INPUT",
  SET_PAYOUTS_CASH_INPUT_DIRTY = "SET_PAYOUTS_CASH_INPUT_DIRTY",
  SWITCH_PAYOUTS_CASH_VALIDITY = "SWITCH_PAYOUTS_CASH_VALIDITY",
  SET_PAYOUTS_CASH_TOKEN = "SET_PAYOUTS_CASH_TOKEN",
  DISABLE_PAYOUTS_CASH_FORM = "DISABLE_PAYOUTS_CASH_FORM",
  ENABLE_PAYOUTS_CASH_FORM = "ENABLE_PAYOUTS_CASH_FORM",
  UPDATE_DOCUMENT_TYPE_NUMBER = "UPDATE_DOCUMENT_TYPE_NUMBER",
}



// WEBPACK FOOTER //
// ./src/containers/PayoutsCash/store/Actions.ts